export default __webpack_public_path__ + "static/media/mango_alone.ee120737.png";